import React from 'react'
import EloModal from 'ui/EloModal'
import { withStores } from 'utils/helpers.utils'

const ProductAccessModal = (props) => {
  const {
    productSessionStore: { accessDeniedModalIsOpen, closeAccessDeniedModal, showAccessLimitedModalMode },
    courseSessionsStore: { item },
    sellablesStore: {
      item: { form },
    },
    username,
    historyPush,
  } = props

  const closeModalCallback = () => closeAccessDeniedModal(username, historyPush, item?.sellableId, form)

  const productAccessModalProperties = {
    anotherPersonViewing: {
      accessModalIsOpen: accessDeniedModalIsOpen,
      accessModalTitle: I18n.t('react.payer.access.course_access.currently_viewing_title'),
      accessModalSubmitButtonChild: I18n.t('react.shared.button.ok'),
      accessModalCloseCallback: closeModalCallback,
      accessModalSubmit: closeModalCallback,
      accessModalCancel: false,
      accessModalIconProps: { className: 'fas fa-exclamation-triangle elo-modal__warning-sign' },
      accessModalMessage: I18n.t('react.payer.access.course_access.currently_viewing_body'),
    },
    tryToRejoin: {
      accessModalIsOpen: accessDeniedModalIsOpen,
      accessModalTitle: I18n.t('react.payer.access.course_access.try_rejoin_title'),
      accessModalSubmitButtonChild: I18n.t('react.shared.button.close'),
      accessModalCloseCallback: closeModalCallback,
      accessModalSubmit: false,
      accessModalCancel: closeModalCallback,
      accessModalIconProps: { className: 'fas fa-clock elo-modal__warning-sign' },
      accessModalMessage: I18n.t('react.payer.access.course_access.try_rejoin_body'),
    },
  }

  const {
    accessModalIsOpen,
    accessModalTitle,
    accessModalSubmitButtonChild,
    accessModalCloseCallback,
    accessModalSubmit,
    accessModalCancel,
    accessModalIconProps,
    accessModalMessage,
  } = productAccessModalProperties[showAccessLimitedModalMode] || {}

  return (
    <EloModal
      isOpen={accessModalIsOpen}
      title={accessModalTitle}
      submit={accessModalSubmit}
      toggle={accessModalCloseCallback}
      cancel={accessModalCancel}
      submitButtonChild={accessModalSubmitButtonChild}
      iconProps={accessModalIconProps}
      onlySubmit
    >
      <EloModal.Message centered>
        <div
          dangerouslySetInnerHTML={{
            __html: accessModalMessage,
          }}
        />
      </EloModal.Message>
    </EloModal>
  )
}

const stores = ['productSessionStore', 'courseSessionsStore', 'sellablesStore']

export default withStores(stores, ProductAccessModal)
